import { Callback } from '@/layouts/core/types/core'
import React from 'react'
import {
  useDispatch,
  useSelector
} from 'react-redux'
import { useRouter } from 'next/router'
import {
  Box,
  Typography
} from '@mui/material'
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart'
import {
  getCartQuantitySelector,
  useCartItems
} from '@/modules/cart/cartSlice'
import CartItemCard from '@/modules/cart/components/CartItemCard'
import ChronoModal from '@/layouts/core/components/ChronoModal'
import { useCreateAnonymousSessionMutation } from '@/app/ctliveApi'
import { cacheToken } from '@/modules/session/sessionSlice'
import { handleCheckoutPageUrl } from '@/common/utils'

import 'react-image-gallery/styles/css/image-gallery.css'

const CartDialog = ({ renderButton }: { renderButton: (cb: Callback) => React.ReactNode }) => {
  const router = useRouter()
  const totalQuantity = useSelector(getCartQuantitySelector)
  const cartItems = useCartItems()
  const [createAnonymousSession, { isLoading, isSuccess }] = useCreateAnonymousSessionMutation()

  const dispatch = useDispatch()
  const onCheckout = () => {
    createAnonymousSession()
      .unwrap()
      .then(({ token }) => {
        dispatch(
          cacheToken(token)
        )
        // noinspection JSIgnoredPromiseFromCall
        handleCheckoutPageUrl(router)
      })
  }

  const title = (
    <Box display={'flex'} flexDirection={'row'} justifyContent={'start'} alignItems={'center'}>
      <AddShoppingCartIcon height={'100%'} style={{ marginRight: 10 }} />
      <Typography variant={'h6'}>({totalQuantity}) Items have been added to your cart</Typography>
    </Box>
  )

  return (
    <ChronoModal
      data-cy={'cart_dialog'}
      size={'lg'}
      title={title}
      renderButton={renderButton}
      cancelButton={{
        text: 'Continue Shopping'
      }}
      isLoading={isLoading || isSuccess}
      submitButton={{
        text: 'Checkout',
        disabled: totalQuantity === 0,
        onClick: onCheckout
      }}
    >

      <Box marginTop={1}>
        {cartItems.map(cartItem => (
          <CartItemCard
            key={`${cartItem.product.id}${cartItem.option?.id}`}
            cartItem={cartItem} />
        ))}
      </Box>

    </ChronoModal>
  )
}

export default CartDialog